import { CustomFieldColumnValueDto, EntityTypeCustomFieldDto } from '@http/clients/reporting-app/reporting-api-proxies';
import { CustomFieldTypes } from '@models/enums/CustomFieldTypes';
import { ColDef, ValueGetterParams } from 'ag-grid-enterprise';

interface GridRowWithCustomFields {
    customFieldColumnValues?: CustomFieldColumnValueDto[];
}

function getCustomFieldCellValue(row: GridRowWithCustomFields | undefined, fieldId: number): unknown {
    const values = row?.customFieldColumnValues;
    if (!values?.length) return undefined;

    const matchValue = values.find((value) => value.entityTypeCustomFieldId === fieldId);
    if (!matchValue) return undefined;

    return matchValue.rawValue ?? matchValue.value;
}

function getColumnTypeForCustomField(customFieldTypeId: number): string | undefined {
    switch (customFieldTypeId) {
        case CustomFieldTypes.Currency:
            return 'currency';
        case CustomFieldTypes.Number:
            return 'decimal2';
        case CustomFieldTypes.Date:
            return 'date';
        case CustomFieldTypes.MultipleSelectionList:
            return 'array';
        case CustomFieldTypes.Boolean:
            return 'booleanYesNo';
        default:
            return undefined;
    }
}

function buildCustomFieldColDefs(columns: EntityTypeCustomFieldDto[]): ColDef[] {
    return columns
        .filter((column) => column.isActive)
        .map((column) => {
            const fieldId = column.id;
            const colDef: ColDef = {
                colId: `customField_${fieldId}`,
                headerName: column.name ?? column.description ?? '',
                enableRowGroup: false,
                valueGetter: (params: ValueGetterParams) =>
                    getCustomFieldCellValue(params.data as GridRowWithCustomFields | undefined, fieldId)
            };

            const columnType = getColumnTypeForCustomField(column.customFieldTypeId);
            if (columnType) colDef.type = columnType;

            return colDef;
        });
}

export function mergeCustomFieldColumnsGridSettings(
    baseSettings: ColDef[],
    customFieldColumns: EntityTypeCustomFieldDto[]
): ColDef[] {
    return [...baseSettings, ...buildCustomFieldColDefs(customFieldColumns)];
}
